import { render, staticRenderFns } from "./ReviewEmpty.vue?vue&type=template&id=66dc35ea&scoped=true&"
import script from "./ReviewEmpty.vue?vue&type=script&lang=js&"
export * from "./ReviewEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ReviewEmpty.vue?vue&type=style&index=0&id=66dc35ea&lang=scss&scoped=true&"
import style1 from "./ReviewEmpty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc35ea",
  null
  
)

export default component.exports